// Import style
import './style.scss';

// Import utilities
import { isDefined } from '@automator/utilities';

// Import images
import './img/delay-or-schedule-actions-landscape-2@2x.png';
import './img/delay-or-schedule-actions-2@2x.png';
import './img/multiple-actions-landscape-2@2x.png';
import './img/multiple-actions-2@2x.png';
import './img/multiple-triggers-landscape-2@2x.png';
import './img/multiple-triggers-2@2x.png';

import DashboardCredits from '@pages/dashboard/credits';

/**
 * Class representing the Dashboard page.
 *
 * This class handles the initialization of the "DashboardCredits" section if the current page is the Dashboard page. It provides a getter to check if the current page is the Dashboard page.
 */
export default class Dashboard {
	/**
	 * Constructs a new instance of the class.
	 *
	 * If the current page is the Dashboard page, it initializes the "DashboardCredits" section.
	 */
	constructor() {
		// Check if it's the Dashboard page
		if ( this.isDashboardPage ) {
			// Start the "Credits" section
			new DashboardCredits();
		}
	}

	/**
	 * Determines if the current page is the "Dashboard" page
	 *
	 * @return {Boolean} True if the current page is the "Dashboard" page
	 */
	get isDashboardPage() {
		return isDefined( document.getElementById( 'uap-dashboard' ) );
	}
}
